// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format12 } from '../../constants';

import { format5 } from '../../constants';

/** Liberia */
const LR: PhoneNumberData = [231, 'LR', 7, format12, 9, format5];

export default LR;
